module.exports = __webpack_public_path__ + "static/traditions-on-the-lake-lake-hartwell-restaurant-8e84e0b163a58bb23eb6c2c856155fd3.jpg";